import React from "react";

import "./App.css";
import SuperAdminRoute from "./pages/SuperAdminRoute";

const App: React.FC = () => <SuperAdminRoute />;

export default App;
